import { type FunctionComponent } from "react";
import { graphql, useFragment } from "react-relay";

import { ArticleSpeechSkipContainer } from "~/components/article/article-speech/article-speech-skip-container";
import type { articleSpeechInlineWidgetArticle$key } from "~/queries/__generated__/articleSpeechInlineWidgetArticle.graphql";

import { ArticleSpeechInlineWidgetContextProvider } from "./contexts";
import { ArticleSpeechInlineWidgetGeneric } from "./variants/generic";
import { ArticleSpeechInlineWidgetPosties } from "./variants/posties";

export type ArticleSpeechInlineWidgetProps = {
  className?: string;
  onClick?: () => void;
  reference: articleSpeechInlineWidgetArticle$key;
  variant: "posties" | "generic" | "generic-minify";
};

export const ArticleSpeechInlineWidget: FunctionComponent<ArticleSpeechInlineWidgetProps> = ({
  className,
  onClick,
  reference,
  variant,
}) => {
  const article = useFragment(
    graphql`
      fragment articleSpeechInlineWidgetArticle on Article {
        ...genericArticleSpeechInlineWidgetGenericArticle
      }
    `,
    reference,
  );

  const handleRenderInlineWidget = () => {
    switch (variant) {
      case "posties":
        return <ArticleSpeechInlineWidgetPosties className={className} />;
      case "generic-minify":
        return (
          <ArticleSpeechInlineWidgetGeneric
            className={className}
            isMinify={true}
            reference={article}
          />
        );
      default:
        return <ArticleSpeechInlineWidgetGeneric className={className} reference={article} />;
    }
  };
  return (
    <ArticleSpeechInlineWidgetContextProvider onClick={onClick}>
      <ArticleSpeechSkipContainer>{handleRenderInlineWidget()}</ArticleSpeechSkipContainer>
    </ArticleSpeechInlineWidgetContextProvider>
  );
};

ArticleSpeechInlineWidget.displayName = "ArticleSpeechInlineWidget";
